export default __webpack_public_path__ + "static/media/cp_geo_wf.de394ff1.svg";